import { Link } from 'react-router-dom';
import { t } from '../i18n/index.js';

export function NotFoundPage() {
  const labels = t().notFound;

  return (
    <div style={{ maxWidth: '52ch' }}>
      <h1>{labels.title}</h1>
      <p style={{ color: 'var(--c-text-muted)' }}>{labels.text}</p>
      <Link to="/">{labels.back}</Link>
    </div>
  );
}
